import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-input-sensitive-text',
  templateUrl: './st-input-sensitive-text.component.html',
  styleUrls: ['./st-input-sensitive-text.component.scss'],
  standalone: false
})
export class StInputSensitiveTextComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'textId';

  @Input()
  idToggleTextVal: string = 'textToggleId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Type here';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Input()
  requiredVal: boolean = false;

  textVisible: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();

  constructor() {
  }

  toggle() {
    const passwordInput = document.getElementById(this.idVal);
    this.textVisible = !this.textVisible;
    // @ts-ignore
    if (passwordInput.type === "password") {
      // @ts-ignore
      passwordInput.type = "text";
    } else {
      // @ts-ignore
      passwordInput.type = "password";
    }
  }
}
